export default __webpack_public_path__ + "static/media/new.9333aca9.png";